import { jt, t } from 'ttag'

import { Grid } from '@h2/components/containers/grid'

const WorkKeys = ({ occupation }) => {
  const certificateType = occupation.workKeys.crc ? (
    <b>{occupation.workKeys.crc.name}</b>
  ) : null
  const columns = [
    {
      id: 'name',
      sortable: true,
      width: '80%',
      label: t`Skill`
    },
    {
      id: 'level',
      sortable: true,
      label: t`Level`
    }
  ]

  return (
    <div>
      {occupation.workKeys.crc && (
        <p>{jt`This occupation requires a ${certificateType} certificate`}</p>
      )}
      {occupation.workKeys.skills === 0 ? null : (
        <Grid
          columns={columns}
          data={occupation.workKeys.skills}
          options={{ disableFilters: true, fullWidth: true }}
          rowIdKey="naics"
          isPagerVisible={false}
          isRowSelectable={false}
        />
      )}

      <p className="disclaimer">{t`WorkKeys\u00AE is a registered trademark of ACT, Inc., which was not involved in the production of, and does not endorse, this product.`}</p>
    </div>
  )
}

export { WorkKeys }
